module.exports = __webpack_public_path__ + "static/media/IconTemplates_-69.e8d563f8.svg";